export default __webpack_public_path__ + "static/media/CRUSH.b41d2d25.svg";